class Helper {

    trim(text) {

        return text.replace(/^\s+|\s+$/g, '');
    }

    iOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    }

    desktop() {
        return !(/iPad|iPhone|iPod|Android/.test(navigator.userAgent)) && window.screen.width > 1024
    }

    webView() {
        const userAgent = window.navigator.userAgent.toLowerCase()
        const safari = /safari/.test(userAgent)
        const ios = /iphone|ipod|ipad/.test(userAgent)
        let isWebView = false

        if (ios && !safari) {
          isWebView = true
        } else {
          isWebView = userAgent.indexOf("mozilla/5.0") > -1 && userAgent.indexOf("android") > -1 && userAgent.indexOf("applewebkit") > -1 && userAgent.indexOf("version") > -1
        }

        return isWebView
    }

    isMessengerWebview() {

        let userAgent = window.navigator.userAgent.toLowerCase();
        let messenger = /messengerlite/.test( userAgent );

        if ( messenger ) return true
        return false
    }

    numpad (n) {
        return (n < 10 ? '0' : '') + n
    }

    setNewVh () {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = document.documentElement.clientHeight * 0.01
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`)
        document.getElementById('app').style.height = 'calc((var(--vh, 1vh) * 100))'

        // We listen to the resize event
        window.addEventListener('resize', () => {
            // We execute the same script as before
            let vh = document.documentElement.clientHeight * 0.01
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        })
    }

    chunk (arr, size) {
        return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
            arr.slice(i * size, i * size + size)
        )
    }

    shortName (name) {
        let shortern = name.replace(/\s/g, '').substr(0, 9).toLowerCase()

        return shortern.charAt(0).toUpperCase() + shortern.slice(1)
    }

    ajaxBlob (path, successCallBack, errorCallBack) {

        let storagekey = path.split('/').pop()
        let cacheSong = window.localStorage.getItem(storagekey)

        if (cacheSong) {
            successCallBack(`data:audio/mp3;base64,${cacheSong}`)
            return {
                abort: function () {}
            }
        }

        let req = new XMLHttpRequest()
        req.open('GET', path, true)
        req.responseType = 'blob'

        req.onload = function() {
            if (this.status === 200) {
                var resBlob = this.response;
                var src = URL.createObjectURL(resBlob)

                successCallBack(src)
            }
        }

        req.onerror = function() {
            errorCallBack('Please check your path AUDIO/VIDEO.')
        }

        req.send()

        return req
    }

    quizFontSize(id, range) {
        if (!document.getElementById(id)) {
            return
        }

        let fontSize = '25px'

        if (window.innerWidth > 991) {
            if (range <= 45) {
                fontSize = '30px'
            } else if (range >= 65) {
                fontSize = '20px'
            }
            document.getElementById(id).style.fontSize = fontSize
        } else {
            if (range <= 45) {
                fontSize = '26px'
            } else if (range >= 65) {
                fontSize = '18px'
            }
            document.getElementById(id).style.fontSize = fontSize
        }
    }

    gTrackEvent(label, data) {
        const isDisabled = !process.env.VUE_APP_ENABLE_GOOGLE_TRACKER || process.env.VUE_APP_ENABLE_GOOGLE_TRACKER == 'false'

        if (process.env.VUE_APP_GOOGLE_TRACK_DEBUG) {
            const log = console.log
            const table = console.table

            log(`%c label: ${label}`, 'color: blue; font-weight: bold')
            table(data)
        }

        if (isDisabled) {

            if (typeof data.event_callback == 'function') {
                data.event_callback()
            }

            return
        }

        if (typeof gtag != 'function') {
            return
        }

        gtag('event', label, data);
    }

    slugify (val) {
        return val.replace(/[^0-9a-z]/g, '')
    }

    setFormatText (inputText, breakNumber ) {

        return inputText

        // wait until it perfect !!
        // let splitText = inputText.split(' ')

        // if (splitText.length > breakNumber && splitText.length <= (breakNumber * 2)) {
        //     splitText.splice(Math.ceil(splitText.length / 2 ), 0, '<br>')
        // }

        // return splitText.join(' ')
    }

    getTimeZone() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone
    }

    randomUid() {
        const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        const counter = (Math.floor(Math.random() * 10000)).toString(16);

        const paddingLength = 21 - timestamp.length - counter.length;

        const padding = '0'.repeat(paddingLength);
        const randomPart = padding + counter + '0'.repeat(6 - counter.length);

        return timestamp + randomPart;
    }
}

export default new Helper
